import hdapi from "./common/hdapi";
import "./plugins/gevt";
import Vue from "vue";
import router from "./router";
import App from "./App.vue";
import i18n from "./i18n";
import {store, ajax} from "./plugins";
import {traffic, percent} from "./common/utils";
import * as utils from "./common/utils";
import "./styles/index.less";
import "probe-image-size";
import "wasm-imagemagick";

window.utils = utils;
window.axios = ajax;
Vue.prototype.$get = ajax.get;
Vue.prototype.$post = ajax.post;
Vue.prototype.$app = store;
Vue.prototype.$hdapi = hdapi;
Vue.prototype.$local = store.local;
Vue.prototype.$toast = store.toast;
Vue.prototype.$dlg = store.dialog;
Vue.prototype.$util = {traffic, percent};
// 设置哪些链接通过默认浏览器打开，否则在新窗口打开
hdapi.setExternalURLFilter(function (url) {
	console.log(url);
	return true;
});
if (!store.local.outputPath)
	hdapi.getPath("desktop").then((x) => {
		store.local.outputPath = x;
	});

window["vue"] = new Vue({
	router,
	i18n,
	data: {},
	render: (h) => h(App),
}).$mount("#app");
